import { computed, getCurrentInstance } from 'vue'
import useRouter from '@/hooks/useRouter'
import { Project } from '../types/main'
export function useProject() {
    const root = getCurrentInstance()!.proxy as any
    const { route } = useRouter(root)
    const project = computed<Project>(() => root.$store.getters.projectById(route.value.params.id))
    return { project }
}
